type Props = {
  className?: string;
};

export function SaleStrip({ className }: Props) {
  return (
    <div
      className={`overflow-hidden bg-[#fceeed] border-y border-[#e03223] ${className ?? ""}`}
    >
      <div className="flex animate-[marquee_10s_linear_infinite] whitespace-nowrap">
        {Array.from({ length: 12 }).map((_, i) => (
          <span
            key={i}
            className="mx-[8.5px] text-base font-normal text-[#e03223]"
          >
            SALE
          </span>
        ))}
      </div>
    </div>
  );
}
